module.exports = __webpack_public_path__ + "media/images/culture-action 2-511ba8beb5442b851587c449fba15b23.png";